import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Container, Paper, Button } from '@mui/material';
import { getToken } from '../../../app/auth';
import { getWorkspaces } from '../../../app/api';

const WORKSPACE_STORAGE_KEY = 'eagle_workspace_id';

const DesktopConnectPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [choosing, setChoosing] = useState(false);
  const [workspaces, setWorkspaces] = useState([]);

  const returnUrl = searchParams.get('return');

  useEffect(() => {
    if (!returnUrl) {
      setError('Link inválido para conectar o Eagle Desktop.');
      return;
    }
    try {
      sessionStorage.setItem('eagle_desktop_return', returnUrl);
    } catch (_) {}

    const token = getToken();
    if (!token) {
      navigate(`/login?desktop_return=${encodeURIComponent(returnUrl)}`, { replace: true });
      return;
    }

    const finish = async (ws) => {
      try {
        const u = new URL(returnUrl);
        u.searchParams.set('token', token);
        u.searchParams.set('workspace_id', ws.id);
        u.searchParams.set('workspace_name', ws.name || '');
        window.location.href = u.toString();
      } catch {
        setError('Endereço de retorno inválido.');
      }
    };

    const load = async () => {
      try {
        const res = await getWorkspaces();
        const list = res.data?.workspaces || [];
        if (list.length === 0) {
          setError('Nenhum workspace encontrado na sua conta.');
          return;
        }
        const savedId = localStorage.getItem(WORKSPACE_STORAGE_KEY);
        const selected = list.find((w) => w.id === savedId) || null;
        if (list.length === 1) {
          await finish(list[0]);
          return;
        }
        if (selected) {
          await finish(selected);
          return;
        }
        setWorkspaces(list);
        setChoosing(true);
      } catch (err) {
        setError(err.message || 'Erro ao carregar workspaces');
      }
    };

    load();
  }, [returnUrl, navigate]);

  if (error) {
    return (
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Paper sx={{ p: 3 }}>
          <Typography color="error" gutterBottom>{error}</Typography>
          <Button variant="contained" onClick={() => navigate('/login')}>Ir para login</Button>
        </Paper>
      </Container>
    );
  }

  if (choosing) {
    return (
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>Escolha o workspace para o Eagle Desktop</Typography>
          {workspaces.map((ws) => (
            <Button
              key={ws.id}
              fullWidth
              variant="outlined"
              sx={{ mt: 1 }}
              onClick={() => {
                try {
                  localStorage.setItem(WORKSPACE_STORAGE_KEY, ws.id);
                } catch (_) {}
                const token = getToken();
                const u = new URL(returnUrl);
                u.searchParams.set('token', token);
                u.searchParams.set('workspace_id', ws.id);
                u.searchParams.set('workspace_name', ws.name || '');
                window.location.href = u.toString();
              }}
            >
              {ws.name}
            </Button>
          ))}
        </Paper>
      </Container>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '50vh' }}>
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>Conectando ao Eagle Desktop…</Typography>
    </Box>
  );
};

export default DesktopConnectPage;
